import { IS_DEVELOPMENT } from 'src/config';

export function sanitizeRedirectUrl(
  str?: string,
  options?: { preventLoginAndLogoutRedirects?: boolean }
) {
  if (!str) return str;

  try {
    const url = new URL(str, window.location.origin);

    if (
      options?.preventLoginAndLogoutRedirects &&
      (url.pathname === '/login' || url.pathname === '/logout')
    ) {
      return '';
    }

    url.searchParams.delete('state');
    url.searchParams.delete('code');
    url.searchParams.delete('error');
    url.searchParams.delete('error_description');

    return url.pathname + url.search + url.hash;
  } catch (e) {
    if (IS_DEVELOPMENT) {
      console.error('Unable to sanitize redirect url:', str);
    }
    return '';
  }
}
